import { z } from 'zod';

const UUID_V1_TO_V7_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-7][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const UuidSchema = z
  .string()
  .regex(UUID_V1_TO_V7_REGEX, 'Invalid UUID');
